import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../layout-crud-index/layout-crud-index.module';
import { CustomerParcelCESComponent } from './crud-ces/crud-ces.component';
import { CustomerParcelIndexComponent } from './crud-index/crud-index.component';
import { CustomerParcelService } from './crud-service';
import { CustomerParcelIndexSelectComponent } from './crud-index/crud-index-select.component';
import { CustomerParcelCrudIndex } from './crud-index/crud-index';
import { CurrencyMaskModule } from 'ng2-currency-mask';



@NgModule({
  declarations: [
    CustomerParcelCrudIndex,
    CustomerParcelIndexComponent,
    CustomerParcelIndexSelectComponent,
    CustomerParcelCESComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    TableResponsiveModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    CurrencyMaskModule
  ],
  providers: [
    CustomerParcelService
  ],
  exports: [
    CustomerParcelIndexComponent,
    CustomerParcelCESComponent
  ]
})
export class CustomerParcelModule { }
